@if (devicesWithoutRadioControl()?.length && (selectedDropOffData$() | async)?.length) {
  <vectronic-alert type="error" class="drop-off-table__error">
    {{ devicesWithoutRadioControl().join(', ') }} has no radio control!
  </vectronic-alert>
}
@if (devicesWithoutDeviceManagerPermission()?.length && (selectedDropOffData$() | async)?.length) {
  <vectronic-alert type="error" class="drop-off-table__error">
    {{ devicesWithoutDeviceManagerPermission().join(', ') }} has no device_manager permission!
  </vectronic-alert>
}
@if (isMaxDropOffsReachedWithShortHeaderFormat()) {
  <vectronic-alert type="error" class="drop-off-table__error">
    {{ collarsWithShortHeaderFormatJoin() }}: Can not be combined in one command
  </vectronic-alert>
}
<div class="drop-off-table">
  <table-datatable
    class="drop-off-table__table"
    [datatableConfig]="datatableConfig()"
    [data]="selectedDropOffData$() | async"
    [isLoading]="loading()"
  >
    <ng-template #headerButtons>
      <div class="drop-off-table__top-menu" [matTooltip]="fireDropOffTooltip()">
        <button
          (click)="submitFireDropOff.emit()"
          class="drop-off-table__action"
          color="warn"
          mat-button
          [disabled]="isDisabled()"
          [attr.data-testid]="'drop-off-btn'"
        >
          <mat-icon>whatshot</mat-icon>
          Fire Drop Off for selection
        </button>
      </div>
    </ng-template>
  </table-datatable>
</div>
